import {
  B_02b,
  BANNER_DEFAULTS,
  hideB02bProps,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B02b_PLASMIC_PROPS = {
  slides: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        image: {
          type: "imageUrl",
        },
        imageAlt: {
          type: "string",
        },
        heading: {
          type: "string",
        },
        description: {
          type: "string",
        },
        buttonText: {
          type: "string",
        },
        buttonUrl: {
          type: "string",
        },
      },
    },
    defaultValue: BANNER_DEFAULTS[B_02b].slides,
    description: "Slides array (B02b only)",
    hidden: hideB02bProps,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
